import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api } from "../../lib/api";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

export default function CmePrograms() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events?category=CME&limit=50").then((r) => setItems(r.data.items || [])); }, []);
  return (
    <div>
      <PageHero title="CME Programs" subtitle="Structured continuing medical education for practising ophthalmologists, residents, and fellows." breadcrumbs={["Home", "Events", "CME Programs"]} />
      <section className="section container-page grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((e, i) => {
          const d = new Date(e.event_date);
          return (
            <FadeUp key={e.id} delay={i * 0.03} className="card-elev p-6 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-widest text-brand-accent font-semibold">CME</span>
                <span className="text-xs text-brand-muted">{e.status}</span>
              </div>
              <h3 className="font-serif text-lg font-bold text-brand-text mt-2 leading-snug">{e.title}</h3>
              <div className="text-sm text-brand-muted mt-3 flex items-center gap-1.5"><MapPin size={14} /> {e.venue}</div>
              <div className="text-sm text-brand-muted mt-1 flex items-center gap-1.5"><Calendar size={14} /> {d.toLocaleDateString()}</div>
              <Link to={`/events/${e.slug}`} className="mt-auto pt-4 inline-flex items-center gap-1.5 text-brand-primary font-semibold text-sm">Details <ArrowRight size={14} /></Link>
            </FadeUp>
          );
        })}
        {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No CME programs scheduled currently.</div>}
      </section>
    </div>
  );
}
